@layer module {
.announcement {
            position: relative;
            overflow: hidden;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            border: 1px solid transparent;
    }

.announcement > * {
            position: relative;
    }

.onboarding-banner-content {
            display: flex;
            flex-flow: column nowrap;
            min-width: 0;
    }

.onboarding-banner-dismiss {
            display: grid;
            place-items: center;
            border: 0;
            cursor: pointer;
    }

.onboarding-banner-stack:empty {
            display: none;
    }

.announcement-rings {
            position: absolute;
            pointer-events: none;
    }

.announcement > .announcement-rings {
            position: absolute;
    }

.announcement-icon {
            display: grid;
            place-items: center;
    }

.announcement-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

      @media (max-width: 640px) {
                .announcement {
                        flex-wrap: wrap;
                        align-items: flex-start;
                    }


                .announcement-text {
                        white-space: normal;
                    }
          }
} // layer module










@layer app {
.announcement {
            gap: $size-12;
            width: 100%;
            padding: $size-12 $size-14;
            border-radius: $size-16;
    }

.onboarding-banner-content {
            flex: 1 1 auto;
            gap: $size-1;
    }

.onboarding-banner-dismiss {
            flex-shrink: 0;
            width: $size-24;
            height: $size-24;
            padding: 0;
            border-radius: 50%;
    }

.onboarding-banner-dismiss svg {
            width: $size-9;
            height: $size-9;
    }

.onboarding-banner-stack {
            margin-bottom: $size-20;
    }

.announcement-rings {
            top: $size-neg-40;
            right: $size-neg-40;
    }

.announcement-icon {
            flex-shrink: 0;
            width: $size-34;
            height: $size-34;
            border-radius: $size-10;
    }

.announcement--action .announcement-icon {
            border-radius: 50%;
    }

.announcement-icon svg {
            width: $size-16;
            height: $size-16;
    }

      @media (max-width: 640px) {
                .onboarding-banner-content {
                        flex-basis: calc(100% - $size-46);
                    }
          }

.announcement {
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 400;
            line-height: normal;
    }

.announcement--brand {
            border-color: var(--color-brand-soft);
            background: var(--color-brand-tint);
    }

.announcement--action {
            border-color: var(--color-action-disabled);
            background: var(--color-action-tint);
    }

.announcement--brand .announcement-rings {
            color: var(--color-brand);
            opacity: 0.14;
    }

.announcement--action .announcement-rings {
            color: var(--color-action-ring);
            opacity: 0.45;
    }

.announcement--brand .announcement-icon {
            background: var(--color-brand);
            color: var(--color-on-brand);
    }

.announcement--action .announcement-icon {
            background: var(--color-action);
            color: var(--color-on-action);
    }

.onboarding-banner-title {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-weight: 600;
            line-height: 1.5;
    }

.announcement-text {
            color: var(--text-body);
    }

.onboarding-banner-dismiss {
            background: var(--icon-button-bg);
            color: var(--text-body);
    }
} // layer app










@layer context {
      @media (min-width: 1175px) {
                .announcement:global(.payment-methods-support-banner) {
                        padding-right: $size-80;
                    }
          }
} // layer context
